import React from 'react'
import * as Variable from '../../../shared/utils/variables'

const SwitcherAbroadDomestic = ({
    ENV_NAME,
    activeTab,
    isCollege,
    onClick,
}) => {
    return (
        isCollege && (
            <div className="switcher-abroad-domestic" onClick={onClick}>
                <span
                    className={`toggled ${
                        activeTab === 'domestic' ? '' : 'active'
                    }`}
                />
                <div className="d-flex justify-content-center align-items-center">
                    <label
                        className={`switcher-label ${
                            activeTab === 'domestic' ? 'active-domestic' : ''
                        }`}
                    >
                        {Variable.DOMESTIC[ENV_NAME]}
                    </label>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                    <label
                        className={`switcher-label ${
                            activeTab === 'abroad' ? 'active-abroad' : ''
                        }`}
                    >
                        {Variable.ABROAD[ENV_NAME]}
                    </label>
                </div>
            </div>
        )
    )
}

export default SwitcherAbroadDomestic
